module.exports = __webpack_public_path__ + "img/9788993094398.1567d0bb.jpg";